import PropTypes from 'prop-types';
import React from 'react';
import Dialog from '../../dialog.jsx';
import classnames from 'classnames';

const MAX_PAGES = 50;

// Example matches:
// Anything that doesn't contain a dash
//
// a2.banana#
// a2.banana# - 49.pant$
// a2.banana#-49.pant$
const detectRange = /^\s*([^-]+)(?:\s*-\s*([^-]+))?$/;

const parsePageString = function(pages, userInput) {
    const match = detectRange.exec(userInput);

    if (match) {
        const first = match[1].trim();
        // The last page is optional, if it isn't provided it should
        // match the first page.
        const last = (match[2] && match[2].trim()) || first;

        let firstPage = pages.find(p => p.label === first);
        let lastPage = pages.find(p => p.label === last);

        if (!firstPage) {
            return { error: `Unable to find page ${first}` };
        }
        if (!lastPage) {
            return { error: `Unable to find page ${last}` };
        }

        if (firstPage.pagenum > lastPage.pagenum) {
            [firstPage, lastPage] = [lastPage, firstPage];
        }

        const firstIndex = pages.indexOf(firstPage);
        const lastIndex = pages.indexOf(lastPage);

        const pageList = pages.slice(firstIndex, lastIndex + 1);
        if (pageList.length > MAX_PAGES) {
            return { error: 'Printing is limited to 50 pages' };
        }

        return { pageList };
    }
};

class PrintSelection extends React.Component {
    static propTypes = {
        routeToContentPage: PropTypes.func.isRequired,
        params: PropTypes.object,
        content: PropTypes.object,
        onSelectPages: PropTypes.func.isRequired,
    };

    state = {};

    range = React.createRef();

    onClose = () => {
        // Pull the query string off the URL.
        this.props.routeToContentPage(this.props.params);
    };

    onSelectPages = () => {
        const { pages } = this.props.content;
        const userInput = this.range.current.value;
        const result = parsePageString(pages, userInput);

        if (result.pageList) {
            this.props.onSelectPages(result.pageList);
        } else {
            this.setState({
                error: result.error,
            });
        }
    };

    onSubmit = event => {
        event.preventDefault();
        this.onSelectPages();
    };

    renderPOD = () => {
        const { print_on_demand_url } = this.props.content;
        if (print_on_demand_url) {
            return (
                <a
                    href={print_on_demand_url}
                    target="_blank"
                    className="order-pod btn btn-primary"
                >
                    <i className="cl-icon cl-icon-truck" />
                    Order a printed copy
                </a>
            );
        }
    };

    render() {
        const { content } = this.props;
        const { error } = this.state;
        const buttons = [];
        buttons.push({
            label: 'Cancel',
            dismiss: true,
        });
        buttons.push({
            label: 'Print',
            primary: true,
            onClick: this.onSelectPages,
        });

        let validationError;
        if (error) {
            validationError = <div className="validation-error">{error}</div>;
        }

        return (
            <Dialog onClose={this.onClose} title="Print" buttons={buttons}>
                <div id="printDialog">
                    <p>Enter Page Range for "{content.title}"</p>
                    <label
                        className={classnames({ 'validation-error': error })}
                        htmlFor="print-range"
                    >
                        Example: 1-10 or 52
                    </label>
                    <input
                        onChange={this.onChange}
                        ref={this.range}
                        name="range"
                        required="required"
                        type="text"
                        id="print-range"
                        aria-required="true"
                    />
                    {validationError}
                    {this.renderPOD()}
                </div>
            </Dialog>
        );
    }
}

export default PrintSelection;



// WEBPACK FOOTER //
// ./src/components/engage_reader/print_dialog/print_selection.jsx